import FilteredAssets from "./FilteredAssets";

export default FilteredAssets;
